/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_Rail_FirstInputs */

const en_start_page_rail_first = /** @type {(inputs: Start_Page_Rail_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booking`)
};

const pl_start_page_rail_first = /** @type {(inputs: Start_Page_Rail_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezerwacja`)
};

/**
* | output |
* | --- |
* | "Booking" |
*
* @param {Start_Page_Rail_FirstInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const start_page_rail_first = /** @type {((inputs?: Start_Page_Rail_FirstInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_Rail_FirstInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_start_page_rail_first(inputs)
	return en_start_page_rail_first(inputs)
});